import $http from '@/0/Libs/HttpHelper.js'
import $msg from '@/0/Libs/MessageHelper.js'

export default {
    
    getApiUrl(shortUrl){
        var baseUrl = "/mGmsH5Api/EnterpriseCodePlanOrder/";
        var apiUrl = baseUrl + shortUrl;
        return apiUrl;
    },

    async getByOpenId(openId) {

        if (!openId) {
            this.$msg.error("找不到单据标识[OpenId]");
            return;
        }
        try {
            var url = this.getApiUrl("Get");
            var postData = {
                OpenId: openId,
            }

            let { data: result } = await $http({
                url: url,
                method: "post",
                data: postData,
            });
            return result;

        } catch (e) {
            console.log("e", e);
            return null;
        }
    },

    async getIndexForm(postData = null) {

        try {
            if(!postData){
                postData = {};
            }
            var url = this.getApiUrl("GetIndexForm");
            let { data: result } = await $http({
                url: url,
                method: "post",
                data: postData
            });

            return result;
        } catch (e) {
            return null;
        }
    },

    async getIndexPaged(postData = null) {

        try {
            if(!postData){
                postData = {};
            }
            console.log("postData",postData);
            var url = this.getApiUrl("GetIndexPaged");
            let { data: result } = await $http({
                url: url,
                method: "post",
                data: postData
            });
            console.log("result11",result);

            return result;
        } catch (e) {
            return null;
        }
    },

    async getIndexTabForm(postData = null) {

        try {
            if(!postData){
                postData = {};
            }
            var url = this.getApiUrl("GetTabIndexForm2");
            let { data: result } = await $http({
                url: url,
                method: "post",
                data: postData
            });

            return result;
        } catch (e) {
            return null;
        }
    },

    async getIndexTabPaged(postData = null) {

        try {
            if(!postData){
                postData = {};
            }
            console.log("postData",postData);
            var url = this.getApiUrl("GetTabIndexPaged2");
            let { data: result } = await $http({
                url: url,
                method: "post",
                data: postData
            });
            console.log("result11",result);

            return result;
        } catch (e) {
            return null;
        }
    },


    async getCreateForm(postData = null) {

        try {
            if(!postData){
                postData = {};
            }
            var url = this.getApiUrl("GetCreateForm");
            let { data: result } = await $http({
                url: url,
                method: "post",
                data: postData
            });

            return result;
        } catch (e) {
            return null;
        }
    },


    async getEditForm(openId) {

        if (!openId) {
            $msg.error("找不到单据标识[OpenId]");
            return null;
        }

        try {
            var postData = {
                OpenId: openId,
            }
            var url = this.getApiUrl("GetEditForm");
            let { data: result } = await $http({
                url: url,
                method: "post",
                data: postData
            });

            return result;
        } catch (e) {
            return null;
        }
    },

    async getDetailForm(openId) {

        if (!openId) {
            $msg.error("找不到单据标识[OpenId]");
            return;
        }

        try {
            var postData = {
                OpenId: openId,
            }
            var url = this.getApiUrl("GetDetailForm");
            let { data: result } = await $http({
                url: url,
                method: "post",
                data: postData
            });

            return result;
        } catch (e) {
            return null;
        }
    },


    async submitCreate(postData) {

        try {
            var url = this.getApiUrl("Create");
            console.log("postData", postData);

            let { data: result } = await $http({
                url: url,
                method: "post",
                data: postData
            });

            return result;
        } catch (e) {
            return;
        }
    },

}


